module.exports = __webpack_public_path__ + "img/bg3.d5c58757.png";